var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDashboardUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.864258 21.2478C0.864258 16.8295 4.44598 13.2478 8.86426 13.2478C13.2826 13.2478 16.8643 16.8295 16.8643 21.2478H14.8643C14.8643 17.9341 12.178 15.2478 8.86426 15.2478C5.55055 15.2478 2.86426 17.9341 2.86426 21.2478H0.864258ZM8.86426 12.2478C5.54926 12.2478 2.86426 9.5628 2.86426 6.2478C2.86426 2.9328 5.54926 0.247803 8.86426 0.247803C12.1793 0.247803 14.8643 2.9328 14.8643 6.2478C14.8643 9.5628 12.1793 12.2478 8.86426 12.2478ZM8.86426 10.2478C11.0743 10.2478 12.8643 8.4578 12.8643 6.2478C12.8643 4.0378 11.0743 2.2478 8.86426 2.2478C6.65426 2.2478 4.86426 4.0378 4.86426 6.2478C4.86426 8.4578 6.65426 10.2478 8.86426 10.2478ZM17.148 13.9506C19.9287 15.2039 21.8643 17.9998 21.8643 21.2478H19.8643C19.8643 18.8118 18.4126 16.7149 16.3271 15.7749L17.148 13.9506ZM16.4605 2.66101C18.4587 3.48483 19.8643 5.45141 19.8643 7.7478C19.8643 10.618 17.6685 12.973 14.8643 13.2254V11.2124C16.561 10.97 17.8643 9.5118 17.8643 7.7478C17.8643 6.36715 17.0659 5.17383 15.9053 4.60415L16.4605 2.66101Z",
    fill: "url(#paint0_linear_3258_50774)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3258_50774",
    x1: 11.3643,
    y1: -5.40811,
    x2: 11.3643,
    y2: 24.9671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACEA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboardUser);
export default __webpack_public_path__ + "static/media/icon-dashboard-user.8dce68807b5c0821ea8c5c362ec6f50e.svg";
export { ForwardRef as ReactComponent };